import { render, staticRenderFns } from "./LinesPallette.vue?vue&type=template&id=94c00f4c&scoped=true"
import script from "./LinesPallette.vue?vue&type=script&lang=js"
export * from "./LinesPallette.vue?vue&type=script&lang=js"
import style0 from "./LinesPallette.vue?vue&type=style&index=0&id=94c00f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c00f4c",
  null
  
)

export default component.exports